import { render, staticRenderFns } from "./AddQuestionByProductCodeStep.vue?vue&type=template&id=58f4d1c2&scoped=true&"
import script from "./AddQuestionByProductCodeStep.vue?vue&type=script&lang=js&"
export * from "./AddQuestionByProductCodeStep.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionByProductCodeStep.vue?vue&type=style&index=0&id=58f4d1c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f4d1c2",
  null
  
)

export default component.exports